import React, { useState, useEffect } from 'react'
import DashboardSummary from '../DashboardSummaryNew';
import callPostApi from 'requests/PostRequests';
import * as Constants from '../../../requests/URLConstants';
import DashboardGroupedBarChart from '../DashboardGroupedBarChart';
import DashboardTable from '../DashboardTable';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import DashboardDonutChart from '../DashboardDonutChart';
import * as SchedulingEfficiencyTables from './tableHeaders';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

const SchedulingEfficiency = (props) => {

    const [reopenCountLoading, setReopenCountLoading] = useState(true);
    const [SchedulerExceptionLoading, setSchedulerExceptionLoading] = useState(true);
    const [SchedulerExceptionData, setSchedulerExceptionData] = useState([]);
    const [SchedulerExceptionTable, setSchedulerExceptionTable] = useState([]);
    const [SchedulerExceptionDownloadableData, setSchedulerExceptionDownloadableData] = useState([]);
    const [incidentManagementSummary, setIncidentManagementSummary] = useState([]);
    const [SchedulerExceptionSummary, setSchedulerExceptionSummary] = useState(0);
    const [LongRunningAutomataDataSummary, setLongRunningAutomataDataSummary] = useState(0);
    const [LongRunningAutomataData, setLongRunningAutomataData] = useState([]);
    const [LongRunningAutomataTable, setLongRunningAutomataTable] = useState([]);
    const [LongRunningAutomataDownloadableData, setLongRunningAutomataDownloadableData] = useState([]);
    const [executionClassificationsData, setExecutionClassificationsData] = useState([]);
    const [executionClassificationsLoading, setExecutionClassificationsLoading] = useState(false);

    useEffect(() => {
        getSchedulingFailuresOccurs(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.workspace);
        getExceptionClassification(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.workspace);
        getLongRunningAutomata(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.workspace);
    }, [props.preferencesChanged])

    useEffect(() => {
        getSchedulingEfficiencySummary();
    }, [SchedulerExceptionSummary, LongRunningAutomataDataSummary]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_state":dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        } 
        return bodyJSON;
    };

    const getSchedulingEfficiencySummary = () => {
        let summary = [
            {
                title: DashboardConstants.NoOfSchedulerException,
                value: SchedulerExceptionSummary
            },
            {
                title: DashboardConstants.TotalNoOfLongRunningAutomatas,
                value: LongRunningAutomataDataSummary
            }
        ];
        setIncidentManagementSummary(summary);
    };

    const prepareExceptionClassificationData = (response) => {
        let graphData = [];
        let tableData = [];
        let tableObj = {};
        let graphObj = {};
        let downloadableData = [];
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            let total = 0;
            for (let i = 0; i < buckets.length; i++) {
                total = total + buckets[i]["1"].value;
            }
            for (let i = 0; i < buckets.length; i++) {
                let percentage = Math.round((buckets[i]["1"].value * 100) / total)
                tableObj = {
                    id: i + 1,
                    resource_name: buckets[i].key,
                    count: buckets[i]["1"].value,
                    countPercentage: percentage
                };
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: percentage,
                };
                tableData.push(tableObj);
                graphData.push(graphObj);
                downloadableData.push(tableObj);
            }
            //console.log("graphData" + graphData)
            //console.log("tableData" + tableData)
            graphData = graphData.slice(0, 10);
        }
        return { tableData, graphData, downloadableData };

    };

    const getSchedulingFailuresOccurs = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSchedulerExceptionLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETSCHEDULINGFAILURES, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareExceptionClassificationData(resp);
                    setSchedulerExceptionData(formattedData.graphData);
                    setSchedulerExceptionTable(formattedData.tableData);
                    setSchedulerExceptionDownloadableData(formattedData.downloadableData);
                    setSchedulerExceptionLoading(false);
                }).catch((error) => {
                    setSchedulerExceptionLoading(false);
                });

        }
    };

    const prepareLongRunningAutomataData = (response) => {
        let graphData = [];
        let tableData = [];
        let tableObj = {};
        let graphObj = {};
        let summary = 0;
        let downloadableData = [];
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            let total = 0;
            for (let i = 0; i < buckets.length; i++) {
                total = total + buckets[i].doc_count;
                summary = buckets.length;
            }
            for (let i = 0; i < buckets.length; i++) {
                let percentage = ((buckets[i].doc_count * 100) / total).toFixed(2)
                tableObj = {
                    id: i + 1,
                    automata_name: buckets[i].key,
                    count: buckets[i].doc_count,
                    countPercentage: percentage
                };
                graphObj = {
                    group: buckets[i].key,
                    key: buckets[i].key,
                    value: buckets[i].doc_count,
                };
                tableData.push(tableObj);
                graphData.push(graphObj);
                downloadableData.push(tableObj);
            }
            graphData = graphData.slice(0, 10);
        }
        return { tableData, graphData, downloadableData, summary };

    };

    const getLongRunningAutomata = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSchedulerExceptionLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETTOPLONGRUNNINGAUTOMATAS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareLongRunningAutomataData(resp);
                    setLongRunningAutomataData(formattedData.graphData);
                    setLongRunningAutomataTable(formattedData.tableData);
                    setLongRunningAutomataDownloadableData(formattedData.downloadableData);
                    setLongRunningAutomataDataSummary(formattedData.summary);
                    setSchedulerExceptionLoading(false);
                }).catch((error) => {
                    setSchedulerExceptionLoading(false);
                });

        }
    };

    const prepareDonutChartData = (response) => {
        let data = [];
        let buckets = response.aggregations["2"].buckets;;
        let total = 0;
        let summary = 0;
        if (buckets.length) {
            for (let i = 0; i < buckets.length; i++) {
                total = total + buckets[i]["1"].value;
                if (buckets[i].key === "Scheduler Exception") {
                    summary = summary + buckets[i]["1"].value;
                }
            }
            for (let i = 0; i < buckets.length; i++) {
                data[i] = {
                    'group': buckets[i].key,
                    'value': buckets[i]["1"].value,
                    'percentage': ((buckets[i]["1"].value * 100) / total).toFixed(2),
                    'chartItems': [{
                        'title': 'Total',
                        'value': buckets[i]["1"].value,
                        'summary': summary
                    }]
                }
            }
        }
        return { data, summary };
    }


    const getExceptionClassification = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setExecutionClassificationsLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETEXCEPTIONCLASSIFICATIONOFINCIDENTS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareDonutChartData(resp);
                setExecutionClassificationsData(formattedData.data);
                setExecutionClassificationsLoading(false);
                setSchedulerExceptionSummary(formattedData.summary);
            }).catch((error) => {
                console.error('Error:', error);
                setExecutionClassificationsLoading(false);
            });

        }
    }

    return (
        <div className="top-margin dashboard incident-management">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={SchedulerExceptionLoading && reopenCountLoading} summary={incidentManagementSummary} title={DashboardConstants.SchedulingEfficiencySummary} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={SchedulerExceptionLoading}
                                    title={DashboardConstants.Top10LongRunningAutomatas}
                                    groupedBarChartData={LongRunningAutomataData}
                                    downloadableData={LongRunningAutomataDownloadableData}
                                    graphAxesTitle={DashboardConstants.Count}
                                    graphBottomTitle=""
                                    headers={SchedulingEfficiencyTables.LongRunningAutomataTableHeaders}
                                />
                                <div className="bold-border-table nested-table">
                                    <DashboardTable loading={SchedulerExceptionLoading} rows={LongRunningAutomataTable} headers={SchedulingEfficiencyTables.LongRunningAutomataTableHeaders}
                                        showPagination={true} isSortable={true} />
                                </div>
                            </div>
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={SchedulerExceptionLoading}
                                    title={DashboardConstants.ResourcesSchedulingFailuresOccurs}
                                    groupedBarChartData={SchedulerExceptionData}
                                    downloadableData={SchedulerExceptionDownloadableData}
                                    graphAxesTitle={DashboardConstants.FailurePercent}
                                    graphBottomTitle=""
                                    headers={SchedulingEfficiencyTables.ExceptionClassificationTableHeaders}
                                />
                                <div className="bold-border-table nested-table">
                                    <DashboardTable loading={SchedulerExceptionLoading} rows={SchedulerExceptionTable} headers={SchedulingEfficiencyTables.ExceptionClassificationTableHeaders}
                                        showPagination={true} isSortable={true} />
                                </div>
                                <div className="donut-graph-container" style={{marginTop:"20px"}}>
                                    <DashboardDonutChart donutChartData={executionClassificationsData} title={DashboardConstants.ExecutionClassificationsOfIncident} loading={executionClassificationsLoading} />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default SchedulingEfficiency;
